module.exports = __webpack_public_path__ + "fonts/loleicons.4e70981.woff2";